import { fetchRequestWithTypes } from './index';

export const POST_CONFIRM_DEBIT_ENROLLMENT_REQUEST =
	'POST_CONFIRM_DEBIT_ENROLLMENT_REQUEST';
export const POST_CONFIRM_DEBIT_ENROLLMENT_SUCCESS =
	'POST_CONFIRM_DEBIT_ENROLLMENT_SUCCESS';
export const POST_CONFIRM_DEBIT_ENROLLMENT_ERRORED =
	'POST_CONFIRM_DEBIT_ENROLLMENT_ERRORED';

export const confirmDebitEnrollment = (address) => {
	return fetchRequestWithTypes({
		types: [
			POST_CONFIRM_DEBIT_ENROLLMENT_REQUEST,
			POST_CONFIRM_DEBIT_ENROLLMENT_SUCCESS,
			POST_CONFIRM_DEBIT_ENROLLMENT_ERRORED,
		],
		request: {
			method: 'POST',
			path: `/checking/api/v1/users/:uuid/confirmEnrollment`,
			body: {
				enrollment: { address },
			},
		},
	});
};

export const GET_DEBIT_ACCOUNT_REQUEST = 'GET_DEBIT_ACCOUNT_REQUEST';
export const GET_DEBIT_ACCOUNT_SUCCESS = 'GET_DEBIT_ACCOUNT_SUCCESS';
export const GET_DEBIT_ACCOUNT_ERRORED = 'GET_DEBIT_ACCOUNT_ERRORED';

export const getDebitAccount = () =>
	fetchRequestWithTypes({
		types: [
			GET_DEBIT_ACCOUNT_REQUEST,
			GET_DEBIT_ACCOUNT_SUCCESS,
			GET_DEBIT_ACCOUNT_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/checking/api/v1/users/:uuid/accounts`,
		},
	});
